import { hasText } from 'shared/lib/common-util'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0071Validator = {
  validateActualDateAndTimeOfDepartureRequirement: ({
    security,
    estimatedDateAndTimeOfDeparture,
  }: {
    security: string
    estimatedDateAndTimeOfDeparture?: string
  }): RuleResult => {
    if (!['1', '3'].includes(security)) return 'NOT_ALLOWED'

    return hasText(estimatedDateAndTimeOfDeparture) ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
  validateEstimateDateAndTimeOfDepartureRequirement: ({
    security,
    actualDateAndTimeOfDeparture,
  }: {
    security: string
    actualDateAndTimeOfDeparture?: string
  }): RuleResult => {
    if (!['1', '3'].includes(security)) return 'NOT_ALLOWED'

    return hasText(actualDateAndTimeOfDeparture) ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
}

export default C0071Validator
